module.exports = __webpack_public_path__ + "static/media/platinum-trophy.41d7f2ab.webp";